export default __webpack_public_path__ + "static/media/conexito.daecf534.png";